<template>
  <classic-container :title="$t('site-administration.topology-change.title') + ': ' + deliveryPoint.referenceNumber">
    <div v-if="deliveryPoint.topologies.length <= 1">
      <p> {{ $t('site-administration.topology-change.paragraph-1') }} </p>
    </div>
    <div class="classic-container-row" v-else>
      <p> {{ $t('site-administration.topology-change.paragraph-2') }} </p>
      <p><label> {{ $t('site-administration.topology-change.active-topology') }} </label>
        {{ activeTopologyName }} </p>
      <v-select
        id="topology-select"
        v-if="canChangeTopology"
        @input="topologySelected"
        outlined
        :items="topologies"
        item-value="id"
        v-model="selectedTopology"
        item-text="name"/>
      <div v-if="isTimerVisible">
        <p>{{
            $t('site-administration.topology-change.paragraph-3', {
              date: topologyChangeDate,
              time: topologyChangeTime
            })
          }}</p>
        <p v-if="timer">{{ $t('site-administration.topology-change.paragraph-4', { timer: timer }) }}</p>
        <p v-if="timer === undefined">{{ $t('site-administration.topology-change.paragraph-5') }}</p>
      </div>
    </div>
  </classic-container>
</template>

<script>
import ClassicContainer from '@/components/classic-container'
import moment from 'moment-timezone'
import 'moment-duration-format'
import getEnv from '@/utils/env'
import localStorage from '@/localStorage'

const TIMER_SECONDS_PREFIX = '00:'
const TOPOLOGY_LAST_CHANGED_SUFFIX = '-TOPOLOGY-LAST-CHANGED'

export default {
  components: { ClassicContainer },
  data () {
    return {
      selectedTopology: null,
      interval: null,
      topologyLastChanged: null,
      timer: null,
      isTimerVisible: false
    }
  },
  name: 'site-topology-change-container',
  props: {
    deliveryPoint: {
      type: Object,
      description: 'Selected Delivery Point'
    },
    canChangeTopology: {
      type: Boolean,
      description: 'Whether user can change topology or not.'
    }
  },
  methods: {
    topologySelected () {
      if (this.selectedTopology !== this.activeTopology?.id) {
        this.isTimerVisible = false
        this.topologyLastChanged = null
        this.$emit('topologyChanged', this.selectedTopology)
      }
    },
    runTimer () {
      const timerEndDate = moment(this.topologyLastChanged).add(15, 'minutes')
      this.timer = null
      this.interval = setInterval(() => this.updateTimer(timerEndDate), 1000)
      this.isTimerVisible = true
    },
    updateTimer (timerEndDate) {
      const remainingTime = moment.duration(timerEndDate.diff(moment()))
      if (remainingTime.asSeconds() > 0) {
        this.timer = this.formatTimer(remainingTime)
      } else {
        this.clearTimer()
      }
    },
    formatTimer (remainingTime) {
      const prefix = remainingTime.asSeconds() < 60 ? TIMER_SECONDS_PREFIX : ''
      return `${prefix}${remainingTime.format('mm:ss')}`
    },
    clearTimer () {
      clearInterval(this.interval)
      localStorage.removeItem(`${this.deliveryPoint.id}${TOPOLOGY_LAST_CHANGED_SUFFIX}`)
      this.timer = undefined
    },
    loadTimer () {
      const selectedTopologyLastChanged = localStorage.getItem(`${this.deliveryPoint.id}${TOPOLOGY_LAST_CHANGED_SUFFIX}`)
      if (selectedTopologyLastChanged) {
        this.topologyLastChanged = moment(selectedTopologyLastChanged).locale(getEnv('VUE_APP_I18N_LOCALE') ? getEnv('VUE_APP_I18N_LOCALE') : 'fr')
        this.runTimer()
      }
    }
  },
  computed: {
    activeTopology () {
      return this.deliveryPoint.topologies.filter(it => it.active)[0]
    },
    activeTopologyName () {
      const active = this.deliveryPoint.topologies.filter(it => it.active)
      if (active.length === 1) {
        return active[0].name
      } else {
        return this.$t('site-administration.topology-change.no-active-topology')
      }
    },
    topologies () {
      return [...this.deliveryPoint.topologies].sort((a, b) => a.name.localeCompare(b.name))
    },
    topologyChangeDate () {
      return this.topologyLastChanged.format('LL')
    },
    topologyChangeTime () {
      return this.topologyLastChanged.format('LT')
    }
  },
  updated () {
    if (this.selectedTopology === this.activeTopology?.id && !this.topologyLastChanged) {
      clearInterval(this.interval)
      this.loadTimer()
    }
  },
  mounted () {
    this.loadTimer()
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>
